module.exports = __webpack_public_path__ + "static/media/work6.65e070d7.jpg";